export default "/images/vendor/@coreui/icons/svg/flag/cif-ug.svg?9e2d42d59a3adee692c8804a570f22fe";